(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/regenerator", "@babel/runtime/helpers/asyncToGenerator", "@babel/runtime/helpers/inheritsLoose", "@babel/runtime/helpers/wrapNativeSuper", "umi-request", "@h3yun/global-provider"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/regenerator"), require("@babel/runtime/helpers/asyncToGenerator"), require("@babel/runtime/helpers/inheritsLoose"), require("@babel/runtime/helpers/wrapNativeSuper"), require("umi-request"), require("@h3yun/global-provider"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.regenerator, global.asyncToGenerator, global.inheritsLoose, global.wrapNativeSuper, global.umiRequest, global.globalProvider);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _regenerator, _asyncToGenerator2, _inheritsLoose2, _wrapNativeSuper2, _umiRequest, _globalProvider) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  _exports.__esModule = true;
  _exports.request = _exports.SysError = _exports.BizError = _exports.BaseError = _exports["default"] = void 0;
  _regenerator = _interopRequireDefault(_regenerator);
  _asyncToGenerator2 = _interopRequireDefault(_asyncToGenerator2);
  _inheritsLoose2 = _interopRequireDefault(_inheritsLoose2);
  _wrapNativeSuper2 = _interopRequireDefault(_wrapNativeSuper2);

  /**
   * @author yangjh
   * @packageDocumentation
   * @module request
   */
  var globalErrorHandlerKey = 'requestGlobalErrorHandler';
  var errorMsgMap = {
    400: ['拒绝访问', '发出的请求有错误，服务器没有进行新建或修改数据的操作。'],
    401: ['拒绝访问', '用户没有权限（令牌、用户名、密码错误）。'],
    403: ['拒绝访问', '用户得到授权，但是访问是被禁止的。'],
    404: ['拒绝访问', '发出的请求针对的是不存在的记录，服务器没有进行操作。'],
    405: ['拒绝访问', '请求的方式错误，请核验'],
    406: ['拒绝访问', '请求的格式不可得。'],
    410: ['拒绝访问', '请求的资源被永久删除，且不会再得到的。'],
    422: ['拒绝访问', '当创建一个对象时，发生一个验证错误。'],
    500: ['服务器错误', '服务器发生错误，请检查服务器。'],
    502: ['服务器错误', '网关错误。'],
    503: ['服务器错误', '服务不可用，服务器暂时过载或维护。'],
    504: ['服务器错误', '网关超时。']
  };

  function getErrorMsg(errorCode) {
    return errorMsgMap[errorCode] || ['错误', '请联系管理员处理'];
  }

  var errorCodeMap = {
    'system.error': '系统错误',
    'returnType.error': '返回类型错误',
    'returnNull.error': '返回结果为空',
    'unknown.error': '未知错误',
    'webapi.parameter.invalid': '非法参数',
    'network.error': '网络错误' // 前端定义的错误 请求未到后台

  };

  var BaseError = /*#__PURE__*/function (_Error) {
    (0, _inheritsLoose2["default"])(BaseError, _Error);

    function BaseError() {
      var _this;

      _this = _Error.apply(this, arguments) || this;
      _this.errorMessage = '';
      _this.errorType = 'SYS';
      _this.errorSource = '';
      _this.errorUrl = '';
      _this.errorTitle = '';
      return _this;
    }

    return BaseError;
  }( /*#__PURE__*/(0, _wrapNativeSuper2["default"])(Error));

  _exports.BaseError = BaseError;

  var SysError = /*#__PURE__*/function (_BaseError) {
    (0, _inheritsLoose2["default"])(SysError, _BaseError);

    function SysError(errorCode, errorUrl) {
      var _this2;

      if (errorUrl === void 0) {
        errorUrl = '';
      }

      _this2 = _BaseError.call(this, "[sys error] status: " + errorCode + ", message: " + getErrorMsg(errorCode)[1] + ", url: " + errorUrl) || this;
      _this2.errorCode = errorCode;

      var _getErrorMsg = getErrorMsg(errorCode),
          _getErrorMsg$ = _getErrorMsg[0],
          title = _getErrorMsg$ === void 0 ? '错误' : _getErrorMsg$,
          _getErrorMsg$2 = _getErrorMsg[1],
          msg = _getErrorMsg$2 === void 0 ? '请联系管理员处理' : _getErrorMsg$2;

      _this2.errorTitle = title;
      _this2.errorType = 'SYS';
      _this2.errorMessage = msg;
      _this2.errorUrl = errorUrl;
      return _this2;
    }

    return SysError;
  }(BaseError);

  _exports.SysError = SysError;

  var BizError = /*#__PURE__*/function (_BaseError2) {
    (0, _inheritsLoose2["default"])(BizError, _BaseError2);

    function BizError(errorCode, errorMessage, errorUrl) {
      var _this3;

      if (errorUrl === void 0) {
        errorUrl = '';
      }

      _this3 = _BaseError2.call(this, "[biz error] code: " + errorCode + ", message: " + errorMessage + ", url: " + errorUrl) || this;
      _this3.errorCode = errorCode;
      _this3.errorMessage = errorMessage;
      _this3.errorUrl = errorUrl;
      _this3.errorTitle = errorCodeMap[errorCode] || errorMsgMap[errorCode] || '错误';
      _this3.errorType = 'BIZ';
      return _this3;
    }

    return BizError;
  }(BaseError);

  _exports.BizError = BizError;

  function standardization(err) {
    if (err instanceof BaseError) {
      return err;
    }

    var _err$message = err.message,
        message = _err$message === void 0 ? '' : _err$message;
    var code = 'network.error';
    var baseError = new BaseError("[network error] code: " + code + ", message: " + message + ", url: " + (err.request ? err.request.url : 'unknown'));
    baseError.errorCode = code;
    baseError.errorTitle = errorCodeMap[code];
    baseError.errorMessage = errorCodeMap[code];

    if (err.request) {
      baseError.errorUrl = err.request.url;
      baseError.request = err.request;
    }

    if (err.response) {
      baseError.response = err.response;
    }

    return baseError;
  }

  function setGlobalErrorHandler(globalErrorHandler) {
    _globalProvider.globalStorage.set(globalErrorHandlerKey, globalErrorHandler);
  }

  function errorHandler(err) {
    var _err = standardization(err); // eslint-disable-next-line no-console


    console.error(_err);

    var globalErrorHandler = _globalProvider.globalStorage.get(globalErrorHandlerKey);

    if (globalErrorHandler) {
      globalErrorHandler(_err);
    }

    return _err;
  }
  /**
   * @author yangjh
   * @packageDocumentation
   * @module request
   */

  /**
   * 配置request请求时的默认参数
   */


  var request = (0, _umiRequest.extend)({
    credentials: 'include',
    errorHandler: errorHandler,
    timeout: 120000,
    requestType: 'json'
  });
  _exports.request = request;
  request.interceptors.response.use( /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(response, options) {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(typeof request.beforeResponseInterceptor === 'function')) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", request.beforeResponseInterceptor(response, options));

            case 2:
              return _context.abrupt("return", response);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
  request.interceptors.response.use(function (response, options) {
    var status = response.status;

    if (status >= 400 && !options.disableSysError) {
      throw new SysError(response.status, response.url);
    }

    return response;
  });
  request.interceptors.response.use( /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(response, options) {
      var data;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(response.status === 200)) {
                _context2.next = 19;
                break;
              }

              if (!(!options.responseType || options.responseType === 'json')) {
                _context2.next = 7;
                break;
              }

              _context2.next = 4;
              return response.clone().json();

            case 4:
              data = _context2.sent;
              _context2.next = 17;
              break;

            case 7:
              if (!(options.responseType === 'blob')) {
                _context2.next = 13;
                break;
              }

              _context2.next = 10;
              return response.clone().blob();

            case 10:
              data = _context2.sent;
              _context2.next = 17;
              break;

            case 13:
              if (!(options.responseType === 'text')) {
                _context2.next = 17;
                break;
              }

              _context2.next = 16;
              return response.clone().text();

            case 16:
              data = _context2.sent;

            case 17:
              if (!(data.errorCode && !options.disableBizError)) {
                _context2.next = 19;
                break;
              }

              throw new BizError(data.errorCode, data.errorMessage, response.url);

            case 19:
              return _context2.abrupt("return", response);

            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }());
  request.setGlobalErrorHandler = setGlobalErrorHandler;
  var _default = request;
  _exports["default"] = _default;
});
